"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultModifiers = exports.Operation = exports.AbstractDataType = exports.DataTypeTypes = exports.influxLoadTypes = exports.LoadTypes = exports.DataCategoryTypes = exports.HubConnections = exports.Connections = exports.Units = exports.DataTypes = exports.DataCategories = exports.GatewayOptions = exports.DeviceOptions = exports.StateOptions = void 0;
function createMappingArray(data, lookupProperty) {
    const mapping = new Map();
    data.forEach((item) => {
        mapping.set(item[lookupProperty], item);
    });
    return new Proxy(data, {
        get(target, prop, receiver) {
            const value = Reflect.get(target, prop, receiver);
            if (value !== undefined) {
                return value;
            }
            if (typeof prop === 'string') {
                return mapping.get(prop);
            }
            return undefined;
        },
    });
}
var PythiaObjectType;
(function (PythiaObjectType) {
    PythiaObjectType["ASSET"] = "asset";
    PythiaObjectType["GATEWAY"] = "gateway";
    PythiaObjectType["RULE"] = "rule";
})(PythiaObjectType || (PythiaObjectType = {}));
var Operation;
(function (Operation) {
    Operation["ADD"] = "add";
    Operation["SUBTRACT"] = "subtract";
})(Operation || (exports.Operation = Operation = {}));
var AbstractDataType;
(function (AbstractDataType) {
    AbstractDataType["AGGREGATE"] = "aggregate";
    AbstractDataType["CALCULATED"] = "calculated";
    AbstractDataType["INSTANTANEOUS"] = "instantaneous";
    AbstractDataType["TARIFF"] = "tariff";
    AbstractDataType["EVENT"] = "event";
    AbstractDataType["MESSAGE"] = "message";
    AbstractDataType["CATEGORICAL"] = "categorical";
    AbstractDataType["ONCE"] = "once";
})(AbstractDataType || (exports.AbstractDataType = AbstractDataType = {}));
var HubConnections;
(function (HubConnections) {
    HubConnections["ETHERNET"] = "ethernet";
    HubConnections["WIFI"] = "wifi";
    HubConnections["MOBILE"] = "mobile";
})(HubConnections || (exports.HubConnections = HubConnections = {}));
var Connections;
(function (Connections) {
    Connections["NB_IOT"] = "NB-IoT";
    Connections["BLUETOOTH"] = "Bluetooth";
    Connections["ZIGBEE"] = "Zigbee";
    Connections["API"] = "API";
    Connections["EMLITE"] = "Emlite";
    Connections["PRESSAC"] = "Pressac";
    Connections["POWER_RADAR"] = "Power Radar";
    Connections["SOLAR_EDGE"] = "Solar Edge";
    Connections["VIRTUAL"] = "Virtual";
    Connections["MODBUS_RTU"] = "Modbus RTU";
    Connections["BACNET_TCP_IP"] = "BACnet/IP";
    Connections["SENSE_ANYWHERE"] = "Sense Anywhere";
    Connections["CONSULTUS"] = "Consultus";
    Connections["DATA_UPLOAD"] = "Manual Data Upload";
})(Connections || (exports.Connections = Connections = {}));
var DataCategoryTypes;
(function (DataCategoryTypes) {
    DataCategoryTypes["ELECTRICITY"] = "ELECTRICITY";
    DataCategoryTypes["CURRENT"] = "CURRENT";
    DataCategoryTypes["WATER"] = "WATER";
    DataCategoryTypes["HOT_WATER"] = "HOT_WATER";
    DataCategoryTypes["GAS"] = "GAS";
    DataCategoryTypes["GENERATION"] = "GENERATION";
    DataCategoryTypes["SIGNAL"] = "SIGNAL";
    DataCategoryTypes["TEMPERATURE"] = "TEMPERATURE";
    DataCategoryTypes["INDOOR_AIR_QUALITY"] = "INDOOR_AIR_QUALITY";
    DataCategoryTypes["CO2"] = "CO2";
    DataCategoryTypes["PRESSURE"] = "PRESSURE";
    DataCategoryTypes["HUMIDITY"] = "HUMIDITY";
    DataCategoryTypes["OCCUPANCY"] = "OCCUPANCY";
    DataCategoryTypes["OPEN_CLOSED"] = "OPEN_CLOSED";
    DataCategoryTypes["ENVIRONMENTAL"] = "ENVIRONMENTAL";
    DataCategoryTypes["SYSTEM"] = "SYSTEM";
    DataCategoryTypes["LIGHT"] = "LIGHT";
    DataCategoryTypes["BATTERY"] = "BATTERY";
    DataCategoryTypes["EXPORTED"] = "EXPORTED";
    DataCategoryTypes["IMPORTED"] = "IMPORTED";
    DataCategoryTypes["INTERNAL"] = "INTERNAL";
})(DataCategoryTypes || (exports.DataCategoryTypes = DataCategoryTypes = {}));
var ModifierTypes;
(function (ModifierTypes) {
    ModifierTypes["GAS_ENERGY_CONVERSION"] = "gas_energy_conversion";
})(ModifierTypes || (ModifierTypes = {}));
const defaultModifiers = {
    [ModifierTypes.GAS_ENERGY_CONVERSION]: {
        id: ModifierTypes.GAS_ENERGY_CONVERSION,
        "operations": [
            {
                "order": 1,
                "operation": "multiply",
                "parameters": [
                    {
                        "name": "volume_correction_factor",
                        "value": 1.02264,
                        "description": "Standard factor to normalize gas volume for temperature and pressure.",
                        "unit": "Dimensionless"
                    }
                ],
                "description": "Correct the measured gas volume."
            },
            {
                "order": 2,
                "operation": "multiply",
                "parameters": [
                    {
                        "name": "calorific_value",
                        "value": 39.5,
                        "description": "Energy content of the gas. CRITICAL: This value varies and should be updated from the gas supplier's bill for accuracy.",
                        "unit": "MJ/m³"
                    }
                ],
                "description": "Apply the gas's energy content (Calorific Value)."
            },
            {
                "order": 3,
                "operation": "divide",
                "parameters": [
                    {
                        "name": "mj_to_kwh_conversion",
                        "value": 3.6,
                        "description": "Fixed constant to convert Megajoules (MJ) to kilowatt-hours (kWh).",
                        "unit": "MJ/kW/h"
                    }
                ],
                "description": "Convert energy unit from MJ to kWh."
            }
        ],
        "finalUnit": "kW/h",
        "name": "Gas Volume to Energy",
        "description": "Accurate gas to energy conversion based on Ofgem formula."
    }
};
exports.defaultModifiers = defaultModifiers;
// Function to get forward type configuration for a given SKU
function getForwardTypeForSku(sku) {
    // Gas pulse SKUs that use gas energy conversion
    const gasPulseSkus = [
        'BACNET_IP_GAS',
        'EA_GAS',
        'BLE_PULSE_DELIVERED_GAS',
        'NB-IOT-PULSE_DELIVERED_GAS'
    ];
    if (gasPulseSkus.includes(sku)) {
        return {
            dataType: DataTypeTypes.GAS_PULSE,
            calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
        };
    }
    return undefined;
}
let DataCategories = [
    {
        id: DataCategoryTypes.ELECTRICITY,
        name: 'Electricity',
        icon: 'FaBolt',
        glyph: "",
        color: '#FFCA00'
    },
    {
        id: DataCategoryTypes.GENERATION,
        name: 'Generation',
        icon: 'FaSolarPanel',
        glyph: "",
        color: '#3ad56e'
    },
    {
        id: DataCategoryTypes.EXPORTED,
        name: 'Export',
        icon: 'FaArrowAltCircleUp',
        glyph: '',
        color: '#3ad56e'
    },
    {
        id: DataCategoryTypes.IMPORTED,
        name: 'Import',
        icon: 'FaArrowAltCircleDown',
        glyph: '',
        color: '#FFCA00'
    },
    {
        id: DataCategoryTypes.CURRENT,
        name: 'Current',
        icon: 'FaWaveSquare',
        glyph: '',
        color: '#FFCA00'
    },
    {
        id: DataCategoryTypes.WATER,
        name: 'Water',
        icon: 'FaTint',
        glyph: '',
        color: '#00C3EE'
    },
    {
        id: DataCategoryTypes.HOT_WATER,
        name: 'Hot Water',
        icon: 'FaTint',
        glyph: '',
        color: '#f52ec0'
    },
    {
        id: DataCategoryTypes.GAS,
        name: 'Gas',
        icon: 'FaFire',
        glyph: '',
        color: '#D768F2'
    },
    {
        id: DataCategoryTypes.ENVIRONMENTAL,
        name: 'Environmental',
        icon: 'FaBuilding',
        glyph: ''
        // color: '#228B22'
    },
    {
        id: DataCategoryTypes.TEMPERATURE,
        name: 'Temperature',
        icon: 'FaThermometerThreeQuarters',
        glyph: '',
        color: '#e88a16'
    },
    {
        id: DataCategoryTypes.INDOOR_AIR_QUALITY,
        name: 'Indoor Air Quality',
        glyph: '',
        icon: 'FaWind'
    },
    {
        id: DataCategoryTypes.CO2,
        name: 'CO2',
        glyph: '',
        icon: 'FaWind'
    },
    {
        id: DataCategoryTypes.PRESSURE,
        name: 'Pressure',
        icon: 'FaWeightHanging',
        glyph: ''
    },
    {
        id: DataCategoryTypes.HUMIDITY,
        name: 'Humidity',
        icon: 'FaWater',
        glyph: ''
    },
    {
        id: DataCategoryTypes.OCCUPANCY,
        name: 'Occupancy',
        icon: 'FaGhost',
        glyph: ''
    },
    {
        id: DataCategoryTypes.OPEN_CLOSED,
        name: 'Open/Closed',
        icon: 'FaDoorOpen',
        glyph: ''
    },
    {
        id: DataCategoryTypes.LIGHT,
        name: 'Light',
        icon: 'FaLightbulb',
        glyph: ''
    },
    {
        id: DataCategoryTypes.INTERNAL,
        name: 'Battery',
        icon: 'FaBatteryThreeQuarters',
        glyph: ''
    },
    {
        id: DataCategoryTypes.SYSTEM,
        name: 'System',
        icon: 'MdSettings',
        glyph: ''
    },
    {
        id: DataCategoryTypes.BATTERY,
        name: 'Battery',
        icon: 'FaBatteryThreeQuarters',
        glyph: ''
    },
    {
        id: DataCategoryTypes.SIGNAL,
        name: 'Signal',
        icon: 'FaBroadcastTower',
        glyph: ''
    }
];
exports.DataCategories = DataCategories;
exports.DataCategories = DataCategories = DataCategories.map((dc, i) => {
    dc.position = i + 1;
    dc.color = dc.color || '#49b9c4';
    return dc;
});
const Units = [
    {
        id: 'INTERNAL',
        name: 'Internal',
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: 'metric',
        metaData: { symbol: 'W' },
        unitCategory: 'Internal'
    },
    {
        id: 'WATT',
        name: 'Power',
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: 'metric',
        metaData: { symbol: 'W' },
        unitCategory: 'Energy'
    },
    {
        id: 'WATT_HOUR',
        name: 'Energy',
        dataType: AbstractDataType.AGGREGATE,
        unitType: 'metric',
        metaData: { symbol: 'Wh' },
        unitCategory: 'Energy'
    },
    {
        id: 'AMPERE',
        name: 'Current',
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: 'metric',
        metaData: { symbol: 'A' },
        unitCategory: 'Electricity'
    },
    {
        id: 'VOLT',
        name: 'Voltage',
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: 'metric',
        metaData: { symbol: 'V' },
        unitCategory: 'Electricity'
    },
    {
        id: 'LENGTH',
        name: 'Length (Metric)',
        dataType: AbstractDataType.AGGREGATE,
        unitType: 'metric',
        metaData: { symbol: 'm' },
        unitCategory: 'Length'
    },
    {
        id: 'LENGTH_IMPERIAL',
        name: 'Length (Imperial)',
        dataType: AbstractDataType.AGGREGATE,
        unitType: 'nonMetric',
        unitCategory: 'Length',
        metaData: {
            symbol: 'in',
            rules: [
                {
                    "id": "base",
                    "scale_of_base": 1,
                    "name": "Inch",
                    "symbol": "in"
                },
                {
                    "id": "1",
                    "scale_of_base": 12,
                    "name": "Foot",
                    "symbol": "ft"
                },
                {
                    "id": "2",
                    "scale_of_base": 36,
                    "name": "Yard",
                    "symbol": "yd"
                },
                {
                    "id": "3",
                    "scale_of_base": 63360,
                    "name": "Mile",
                    "symbol": "mi"
                }
            ]
        }
    },
    {
        id: 'SQUARED_METER',
        name: 'Area (Metric)',
        dataType: AbstractDataType.AGGREGATE,
        unitType: 'metric',
        metaData: { symbol: 'm²' },
        unitCategory: 'Area'
    },
    {
        id: 'AREA_IMPERIAL',
        name: 'Area (Imperial)',
        dataType: AbstractDataType.AGGREGATE,
        unitType: 'nonMetric',
        unitCategory: 'Area',
        metaData: {
            symbol: 'in²',
            rules: [
                {
                    "id": "base",
                    "scale_of_base": 1,
                    "name": "Square Inch",
                    "symbol": "in²"
                },
                {
                    "id": "1",
                    "scale_of_base": 12,
                    "name": "Square Foot",
                    "symbol": "ft²"
                },
                {
                    "id": "2",
                    "scale_of_base": 36,
                    "name": "Square Yard",
                    "symbol": "yd²"
                },
                {
                    "id": "3",
                    "scale_of_base": 63360,
                    "name": "Square Mile",
                    "symbol": "mi²"
                },
                {
                    "id": "4",
                    "scale_of_base": 6272639.35,
                    "name": "Acre",
                    "symbol": "ac²"
                }
            ]
        }
    },
    {
        id: 'CUBIC_METER',
        name: 'Volume (Metric)',
        dataType: AbstractDataType.AGGREGATE,
        unitType: 'metric',
        metaData: { symbol: 'mᶟ' },
        unitCategory: 'Volume'
    },
    {
        id: 'VOLUME_IMPERIAL',
        name: 'Volume (Imperial)',
        dataType: AbstractDataType.AGGREGATE,
        unitType: 'nonMetric',
        unitCategory: 'Volume',
        metaData: {
            symbol: 'in²',
            rules: [
                {
                    "id": "base",
                    "scale_of_base": 1,
                    "name": "Fluid Ounce",
                    "symbol": "fl oz"
                },
                {
                    "id": "1",
                    "scale_of_base": 5,
                    "name": "Gill",
                    "symbol": "gi"
                },
                {
                    "id": "2",
                    "scale_of_base": 20,
                    "name": "Pint",
                    "symbol": "pt"
                },
                {
                    "id": "3",
                    "scale_of_base": 40,
                    "name": "Quart",
                    "symbol": "qt"
                },
                {
                    "id": "4",
                    "scale_of_base": 160,
                    "name": "Gallon",
                    "symbol": "gal"
                }
            ]
        }
    },
    {
        id: 'GRAM',
        name: 'Weight (Metric)',
        dataType: AbstractDataType.AGGREGATE,
        unitType: 'metric',
        metaData: { symbol: 'g' },
        unitCategory: 'Weight'
    },
    {
        id: 'WEIGHT_IMPERIAL',
        name: 'Weight (Imperial)',
        dataType: AbstractDataType.AGGREGATE,
        unitType: 'nonMetric',
        unitCategory: 'Weight',
        metaData: {
            symbol: 'lb',
            rules: [
                {
                    "id": "base",
                    "scale_of_base": 1,
                    "name": "Pound",
                    "symbol": "lb"
                },
                {
                    "id": "1",
                    "scale_of_base": 0.0625,
                    "name": "ounce",
                    "symbol": "oz"
                },
                {
                    "id": "2",
                    "scale_of_base": 14,
                    "name": "Stone",
                    "symbol": "st"
                },
                {
                    "id": "3",
                    "scale_of_base": 28,
                    "name": "Quarter",
                    "symbol": "qr"
                },
                {
                    "id": "4",
                    "scale_of_base": 112,
                    "name": "Hundredweight",
                    "symbol": "cwt"
                },
                {
                    "id": "5",
                    "scale_of_base": 2240,
                    "name": "Ton",
                    "symbol": "t"
                }
            ]
        }
    },
    {
        id: 'TEMPERATURE',
        name: 'Temperature',
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: 'dimensionless',
        metaData: { symbol: '°C' },
        unitCategory: 'Environmental'
    },
    {
        id: 'INDOOR_AIR_QUALITY',
        name: 'Indoor Air Quality',
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: 'dimensionless',
        metaData: { symbol: 'IAQ' },
        unitCategory: 'Environmental'
    },
    {
        id: 'CO2',
        name: 'Carbon Dioxide',
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: 'dimensionless',
        metaData: { symbol: 'ppm' },
        unitCategory: 'Environmental'
    },
    {
        id: 'PRESSURE',
        name: 'Pressure',
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: 'dimensionless',
        metaData: { symbol: 'hPa' },
        unitCategory: 'Environmental'
    },
    {
        id: 'OCCUPANCY',
        name: 'Occupied/Unoccupied',
        dataType: AbstractDataType.CATEGORICAL,
        unitType: 'boolean',
        metaData: {
            symbol: '0/1',
            categories: [{ "id": "true", "value": 1, "label": "Occupied" }, {
                    "id": "false",
                    "value": 0,
                    "label": "Unoccupied"
                }]
        },
        unitCategory: 'Environmental'
    },
    {
        id: 'LUMINANCE',
        name: 'Luminance',
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: 'metric',
        metaData: { symbol: 'lx' },
        unitCategory: 'Environmental'
    },
    {
        id: 'PERCENTAGE',
        name: 'Percentage',
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: 'dimensionless',
        metaData: { symbol: '%' },
        unitCategory: 'Special'
    },
    {
        id: 'DECIBEL',
        name: 'Decibel',
        dataType: AbstractDataType.INSTANTANEOUS,
        unitType: 'dimensionless',
        metaData: { symbol: 'dB' },
        unitCategory: 'Special'
    },
    {
        id: 'CURRENCY',
        name: 'Currency',
        dataType: AbstractDataType.AGGREGATE,
        unitType: 'currency',
        metaData: { symbol: 'p' },
        unitCategory: 'Special'
    },
    {
        id: 'TIME',
        name: 'Time',
        dataType: AbstractDataType.AGGREGATE,
        unitType: 'nonMetric',
        metaData: {
            symbol: 'h',
            rules: [{
                    "id": "1",
                    "scale_of_base": 0.001,
                    "name": "Millisecond",
                    "symbol": "ms"
                }, {
                    "id": "base",
                    "scale_of_base": 1,
                    "name": "Second",
                    "symbol": "s"
                }, {
                    "id": "2",
                    "scale_of_base": 60,
                    "name": "Minute",
                    "symbol": "min"
                }, {
                    "id": "3",
                    "scale_of_base": 3600,
                    "name": "Hour",
                    "symbol": "h"
                }, {
                    "id": "4",
                    "scale_of_base": 604800,
                    "name": "Week",
                    "symbol": "wk"
                }, {
                    "id": "5",
                    "scale_of_base": 2629746,
                    "name": "Month (Aprox.)",
                    "symbol": "mo"
                }, {
                    "id": "6",
                    "scale_of_base": 31536000,
                    "name": "Year",
                    "symbol": "yr"
                }]
        },
        unitCategory: 'Special'
    },
    {
        id: 'OPEN_CLOSED',
        name: 'Open/Closed',
        dataType: AbstractDataType.CATEGORICAL,
        unitType: 'boolean',
        metaData: {
            symbol: '0/1',
            categories: [{ "id": "true", "value": 1, "label": "Open" }, {
                    "id": "false",
                    "value": 0,
                    "label": "Closed"
                }]
        },
        unitCategory: 'Special'
    },
    {
        id: 'TRUE_FALSE',
        name: 'True/False',
        dataType: AbstractDataType.CATEGORICAL,
        unitType: 'boolean',
        metaData: {
            symbol: '0/1',
            categories: [{ "id": "true", "value": 1, "label": "True" }, {
                    "id": "false",
                    "value": 0,
                    "label": "False"
                }]
        },
        unitCategory: 'Special'
    }
];
exports.Units = Units;
var LoadTypes;
(function (LoadTypes) {
    LoadTypes[LoadTypes["CONSUMPTION_ONLY"] = 0] = "CONSUMPTION_ONLY";
    LoadTypes[LoadTypes["GENERATION_ONLY"] = 1] = "GENERATION_ONLY";
    LoadTypes[LoadTypes["CONSUMPTION_EXPORT"] = 2] = "CONSUMPTION_EXPORT";
})(LoadTypes || (exports.LoadTypes = LoadTypes = {}));
var influxLoadTypes;
(function (influxLoadTypes) {
    influxLoadTypes["DELIVERED"] = "DELIVERED";
    influxLoadTypes["GENERATED"] = "GENERATED";
    influxLoadTypes["CONSUMPTION"] = "CONSUMPTION";
    influxLoadTypes["USAGE_DELIVERED"] = "USAGE_DELIVERED";
    influxLoadTypes["USAGE_CONSUMPTION"] = "USAGE_CONSUMPTION";
})(influxLoadTypes || (exports.influxLoadTypes = influxLoadTypes = {}));
var DataTypeTypes;
(function (DataTypeTypes) {
    DataTypeTypes["CONSUMPTION"] = "CONSUMPTION";
    DataTypeTypes["CONSUMPTION_PULSE"] = "CONSUMPTION_PULSE";
    DataTypeTypes["IMPORTED_DELIVERED"] = "IMPORTED_DELIVERED";
    DataTypeTypes["USAGE_DELIVERED"] = "USAGE_DELIVERED";
    DataTypeTypes["USAGE_CONSUMPTION"] = "USAGE_CONSUMPTION";
    DataTypeTypes["IMPORTED_DELIVERED_SPEND"] = "IMPORTED_DELIVERED_SPEND";
    DataTypeTypes["IMPORTED_DELIVERED_CARBON"] = "IMPORTED_DELIVERED_CARBON";
    DataTypeTypes["IMPORTED_CONSUMPTION"] = "IMPORTED_CONSUMPTION";
    DataTypeTypes["DELIVERED"] = "DELIVERED";
    DataTypeTypes["ASSET_SIGNAL_STRENGTH"] = "ASSET_SIGNAL_STRENGTH";
    DataTypeTypes["NB_IOT_ECL"] = "NB_IOT_ECL";
    DataTypeTypes["ASSET_BATTERY_ALARM"] = "ASSET_BATTERY_ALARM";
    DataTypeTypes["ASSET_BATTERY_VOLTAGE"] = "ASSET_BATTERY_VOLTAGE";
    DataTypeTypes["ROOM_TEMPERATURE"] = "ROOM_TEMPERATURE";
    DataTypeTypes["TEMPERATURE"] = "TEMPERATURE";
    DataTypeTypes["EXTERNAL_TEMPERATURE"] = "EXTERNAL_TEMPERATURE";
    DataTypeTypes["VOC"] = "VOC";
    DataTypeTypes["CO2"] = "CO2";
    DataTypeTypes["PRESSURE"] = "PRESSURE";
    DataTypeTypes["HUMIDITY"] = "HUMIDITY";
    DataTypeTypes["EXTERNAL_HUMIDITY"] = "EXTERNAL_HUMIDITY";
    DataTypeTypes["OCCUPANCY"] = "OCCUPANCY";
    DataTypeTypes["OPEN"] = "OPEN";
    DataTypeTypes["LIGHT"] = "LIGHT";
    DataTypeTypes["ASSET_BATTERY_PERCENT"] = "ASSET_BATTERY_PERCENT";
    DataTypeTypes["WATER_PULSE"] = "WATER_PULSE";
    DataTypeTypes["DELIVERED_WATER"] = "DELIVERED_WATER";
    DataTypeTypes["WATER_PULSE_HOT"] = "WATER_PULSE_HOT";
    DataTypeTypes["DELIVERED_WATER_HOT"] = "DELIVERED_WATER_HOT";
    DataTypeTypes["GAS_PULSE"] = "GAS_PULSE";
    DataTypeTypes["DELIVERED_GAS"] = "DELIVERED_GAS";
    DataTypeTypes["GENERATED"] = "GENERATED";
    DataTypeTypes["CURRENT"] = "CURRENT";
    DataTypeTypes["EXPORTED_DELIVERED"] = "EXPORTED_DELIVERED";
    DataTypeTypes["EXPORTED_CONSUMPTION"] = "EXPORTED_CONSUMPTION";
    DataTypeTypes["EXPORTED_DELIVERED_SPEND"] = "EXPORTED_DELIVERED_SPEND";
    DataTypeTypes["EXPORTED_DELIVERED_CARBON"] = "EXPORTED_DELIVERED_CARBON";
    DataTypeTypes["GENERATED_DELIVERED"] = "GENERATED_DELIVERED";
    DataTypeTypes["GENERATED_CONSUMPTION"] = "GENERATED_CONSUMPTION";
    DataTypeTypes["GAS_ENERGY_DELIVERED"] = "GAS_ENERGY_DELIVERED";
    DataTypeTypes["GAS_ENERGY_CONSUMPTION"] = "GAS_ENERGY_CONSUMPTION";
    DataTypeTypes["GAS_ENERGY_CONVERTED_DELIVERED"] = "GAS_ENERGY_CONVERTED_DELIVERED";
    DataTypeTypes["GAS_ENERGY_CONVERTED_CONSUMPTION"] = "GAS_ENERGY_CONVERTED_CONSUMPTION";
    DataTypeTypes["GATEWAY_MOBILE_STRENGTH"] = "GATEWAY_MOBILE_STRENGTH";
    DataTypeTypes["GATEWAY_WIFI_STRENGTH"] = "GATEWAY_WIFI_STRENGTH";
    DataTypeTypes["DELIVERED_SPEND"] = "DELIVERED_SPEND";
    DataTypeTypes["DELIVERED_GAS_SPEND"] = "DELIVERED_GAS_SPEND";
    DataTypeTypes["DELIVERED_WATER_SPEND"] = "DELIVERED_WATER_SPEND";
    DataTypeTypes["DELIVERED_WATER_HOT_SPEND"] = "DELIVERED_WATER_HOT_SPEND";
    DataTypeTypes["GAS_ENERGY_DELIVERED_SPEND"] = "GAS_ENERGY_DELIVERED_SPEND";
    DataTypeTypes["DELIVERED_CARBON"] = "DELIVERED_CARBON";
    DataTypeTypes["DELIVERED_WATER_CARBON"] = "DELIVERED_WATER_CARBON";
    DataTypeTypes["DELIVERED_WATER_HOT_CARBON"] = "DELIVERED_WATER_HOT_CARBON";
    DataTypeTypes["DELIVERED_GAS_CARBON"] = "DELIVERED_GAS_CARBON";
    DataTypeTypes["GAS_ENERGY_DELIVERED_CARBON"] = "GAS_ENERGY_DELIVERED_CARBON";
    DataTypeTypes["GENERATED_DELIVERED_SPEND"] = "GENERATED_DELIVERED_SPEND";
    DataTypeTypes["GENERATED_DELIVERED_CARBON"] = "GENERATED_DELIVERED_CARBON";
    DataTypeTypes["ASSET_LAST_CONTACTED"] = "ASSET_LAST_CONTACTED";
    DataTypeTypes["GATEWAY_LAST_CONTACTED"] = "GATEWAY_LAST_CONTACTED";
    DataTypeTypes["EVENT"] = "EVENT";
    DataTypeTypes["ERROR"] = "ERROR";
    DataTypeTypes["ASSET_FIRMWARE_VERSION"] = "ASSET_FIRMWARE_VERSION";
    DataTypeTypes["ASSET_FIRMWARE_PROGRESS"] = "ASSET_FIRMWARE_PROGRESS";
    DataTypeTypes["ASSET_CURRENT_STATE"] = "ASSET_CURRENT_STATE";
    DataTypeTypes["ASSET_USER_STATE"] = "ASSET_USER_STATE";
    DataTypeTypes["ASSET_AUTOMATED_STATE"] = "ASSET_AUTOMATED_STATE";
    DataTypeTypes["ASSET_BOOST_FINISH"] = "ASSET_BOOST_FINISH";
    DataTypeTypes["ASSET_SNOOZE_FINISH"] = "ASSET_SNOOZE_FINISH";
    DataTypeTypes["ASSET_SKU"] = "ASSET_SKU";
    DataTypeTypes["MODBUS_MESSAGE"] = "MODBUS_MESSAGE";
    DataTypeTypes["ASSET_DISCONNECTED"] = "ASSET_DISCONNECTED";
    DataTypeTypes["ASSET_INTERMITTENT"] = "ASSET_INTERMITTENT";
    DataTypeTypes["GATEWAY_UPDATE_STATE"] = "GATEWAY_UPDATE_STATE";
    DataTypeTypes["GATEWAY_ACTIVE_CONNECTION"] = "GATEWAY_ACTIVE_CONNECTION";
    DataTypeTypes["GATEWAY_POWER_SOURCE"] = "GATEWAY_POWER_SOURCE";
    DataTypeTypes["GATEWAY_IMSI"] = "GATEWAY_IMSI";
    DataTypeTypes["GATEWAY_TRUST_LIST"] = "GATEWAY_TRUST_LIST";
    DataTypeTypes["GATEWAY_DEVICE_ANALYSIS"] = "GATEWAY_DEVICE_ANALYSIS";
    DataTypeTypes["GATEWAY_UPDATED"] = "GATEWAY_UPDATED";
    DataTypeTypes["DEVICE_UPDATED"] = "DEVICE_UPDATED";
    DataTypeTypes["USER_RESYNC"] = "USER_RESYNC";
    DataTypeTypes["GATEWAY_REPORTED_VERSION_ID"] = "GATEWAY_REPORTED_VERSION_ID";
    DataTypeTypes["RULES_UPDATED"] = "RULES_UPDATED";
    DataTypeTypes["ANOMALIES_UPDATED"] = "ANOMALIES_UPDATED";
    DataTypeTypes["GATEWAY_IP_ADDRESS"] = "GATEWAY_IP_ADDRESS";
    DataTypeTypes["GATEWAY_DISCONNECTED"] = "GATEWAY_DISCONNECTED";
    DataTypeTypes["CLIENT_UPDATE"] = "CLIENT_UPDATE";
    DataTypeTypes["RULE_CLIENT_UPDATE"] = "RULE_CLIENT_UPDATE";
    DataTypeTypes["ONLINE_STATE_UPDATE"] = "ONLINE_STATE_UPDATE";
    DataTypeTypes["RULE_EVENT"] = "RULE_EVENT";
    DataTypeTypes["DEMAND_PHASE_ONE"] = "DEMAND_PHASE_ONE";
    DataTypeTypes["DEMAND_PHASE_TWO"] = "DEMAND_PHASE_TWO";
    DataTypeTypes["DEMAND_PHASE_THREE"] = "DEMAND_PHASE_THREE";
    DataTypeTypes["PF_PHASE_ONE"] = "PF_PHASE_ONE";
    DataTypeTypes["PF_PHASE_TWO"] = "PF_PHASE_TWO";
    DataTypeTypes["PF_PHASE_THREE"] = "PF_PHASE_THREE";
    DataTypeTypes["GATEWAY_CHARGE"] = "GATEWAY_CHARGE";
})(DataTypeTypes || (exports.DataTypeTypes = DataTypeTypes = {}));
let DataTypesArray = [
    {
        type: DataTypeTypes.DELIVERED,
        label: 'Usage',
        dataTypeSibling: DataTypeTypes.CONSUMPTION,
        graphType: 'bar',
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find(u => u.id === 'WATT_HOUR').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'WATT_HOUR'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        influxLoadTypes: {
            [LoadTypes.CONSUMPTION_ONLY]: influxLoadTypes.DELIVERED,
            [LoadTypes.GENERATION_ONLY]: null,
            [LoadTypes.CONSUMPTION_EXPORT]: influxLoadTypes.USAGE_DELIVERED
        },
    },
    {
        type: DataTypeTypes.CONSUMPTION,
        label: 'Rate',
        dataTypeSibling: DataTypeTypes.DELIVERED,
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'WATT').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'WATT'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        summary: true,
        influxLoadTypes: {
            [LoadTypes.CONSUMPTION_ONLY]: influxLoadTypes.CONSUMPTION,
            [LoadTypes.GENERATION_ONLY]: null,
            [LoadTypes.CONSUMPTION_EXPORT]: influxLoadTypes.USAGE_CONSUMPTION
        }
    },
    {
        type: DataTypeTypes.USAGE_DELIVERED,
        graphType: 'line',
        abstractType: AbstractDataType.CALCULATED,
        PythiaCalculation: {
            [Operation.ADD]: [{ type: DataTypeTypes.IMPORTED_DELIVERED }, {
                    type: DataTypeTypes.GENERATED_DELIVERED,
                    fromChildren: true
                }],
            [Operation.SUBTRACT]: [{ type: DataTypeTypes.EXPORTED_DELIVERED }]
        },
        SpendPythiaCalculation: {
            [Operation.ADD]: [{ type: DataTypeTypes.IMPORTED_DELIVERED_SPEND }, {
                    type: DataTypeTypes.GENERATED_DELIVERED_SPEND,
                    fromChildren: true
                }],
            [Operation.SUBTRACT]: [{ type: DataTypeTypes.EXPORTED_DELIVERED_SPEND }]
        }
    },
    {
        type: DataTypeTypes.USAGE_CONSUMPTION,
        graphType: 'bar',
        abstractType: AbstractDataType.CALCULATED,
        PythiaCalculation: {
            [Operation.ADD]: [{ type: DataTypeTypes.IMPORTED_CONSUMPTION }, {
                    type: DataTypeTypes.GENERATED_CONSUMPTION,
                    fromChildren: true
                }]
        }
    },
    {
        type: DataTypeTypes.IMPORTED_DELIVERED,
        label: 'Import',
        dataTypeSibling: DataTypeTypes.IMPORTED_CONSUMPTION,
        graphType: 'bar',
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find(u => u.id === 'WATT_HOUR').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'WATT_HOUR'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.IMPORTED),
        unsafeToRetrieveWithoutLoadType: true,
        influxLoadTypes: {
            [LoadTypes.CONSUMPTION_ONLY]: null,
            [LoadTypes.GENERATION_ONLY]: null,
            [LoadTypes.CONSUMPTION_EXPORT]: influxLoadTypes.DELIVERED
        },
    },
    {
        type: DataTypeTypes.IMPORTED_CONSUMPTION,
        label: 'Import Rate',
        dataTypeSibling: DataTypeTypes.IMPORTED_DELIVERED,
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'WATT').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'WATT'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.IMPORTED),
        removeNegative: true,
        unsafeToRetrieveWithoutLoadType: true,
        summary: true,
        influxLoadTypes: {
            [LoadTypes.CONSUMPTION_ONLY]: null,
            [LoadTypes.GENERATION_ONLY]: null,
            [LoadTypes.CONSUMPTION_EXPORT]: influxLoadTypes.CONSUMPTION
        }
    },
    {
        type: DataTypeTypes.DELIVERED_WATER_HOT,
        dataTypeSibling: DataTypeTypes.WATER_PULSE_HOT,
        label: 'Usage',
        graphType: 'bar',
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find(u => u.id === 'CUBIC_METER').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CUBIC_METER'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.HOT_WATER).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.HOT_WATER),
    },
    {
        type: DataTypeTypes.DELIVERED_GAS,
        dataTypeSibling: DataTypeTypes.GAS_PULSE,
        label: 'Volume',
        unit: Units.find(u => u.id === 'CUBIC_METER').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CUBIC_METER'),
        graphType: 'bar',
        abstractType: AbstractDataType.AGGREGATE,
        category: DataCategories.find(u => u.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.GAS),
    },
    {
        type: DataTypeTypes.GAS_PULSE,
        dataTypeSibling: DataTypeTypes.DELIVERED_GAS,
        label: 'Rate',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'CUBIC_METER').metaData.symbol + '/' + Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CUBIC_METER'),
        applyRate: true,
        rateUnitDetails: Units.find(u => u.id === 'TIME'),
        defaultRateMultiple: 3600,
        category: DataCategories.find(u => u.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.GAS),
        summary: true
    },
    {
        type: DataTypeTypes.GAS_ENERGY_DELIVERED,
        dataTypeSibling: DataTypeTypes.GAS_ENERGY_CONSUMPTION,
        label: 'Energy',
        unit: Units.find(u => u.id === 'WATT_HOUR').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'WATT_HOUR'),
        graphType: 'bar',
        abstractType: AbstractDataType.AGGREGATE,
        category: DataCategories.find(u => u.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.GAS)
    },
    {
        type: DataTypeTypes.GAS_ENERGY_CONSUMPTION,
        dataTypeSibling: DataTypeTypes.GAS_ENERGY_DELIVERED,
        label: 'Rate',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'WATT').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'WATT'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.GAS),
        summary: true
    },
    {
        type: DataTypeTypes.GENERATED,
        dataTypeSibling: DataTypeTypes.GENERATED_CONSUMPTION,
        desiredDirection: 'up',
        label: 'Generation',
        graphType: 'bar',
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find(u => u.id === 'WATT_HOUR').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'WATT_HOUR'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.GENERATION),
        ignoreInReport: true
    },
    {
        type: DataTypeTypes.CONSUMPTION_PULSE,
        dataTypeSibling: DataTypeTypes.DELIVERED,
        label: 'Pulse Rate',
        graphType: 'line',
        downloadOnly: true,
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'WATT').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'WATT'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        summary: true
    },
    {
        type: DataTypeTypes.ASSET_SIGNAL_STRENGTH,
        label: 'Signal Strength',
        graphType: 'line',
        summary: false,
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'DECIBEL').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'DECIBEL'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.SIGNAL),
        pythiaConfig: {
            object: PythiaObjectType.ASSET,
            translatedName: 'signal_strength'
        }
    },
    {
        type: DataTypeTypes.NB_IOT_ECL,
        unit: '',
        label: 'NB-IoT Comms Level',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        category: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.SIGNAL)
    },
    {
        type: DataTypeTypes.ASSET_BATTERY_ALARM,
        label: 'Battery Alarm',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: '',
        category: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.BATTERY),
        pythiaConfig: {
            object: PythiaObjectType.ASSET,
            translatedName: 'battery_alarm'
        }
    },
    {
        type: DataTypeTypes.ASSET_BATTERY_VOLTAGE,
        label: 'Voltage',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'VOLT').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'VOLT'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM)
    },
    {
        type: DataTypeTypes.ROOM_TEMPERATURE,
        label: 'Room Temperature Hive Thermostat',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'TEMPERATURE').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TEMPERATURE'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.TEMPERATURE),
        summary: true,
        allowNegative: true
    },
    {
        type: DataTypeTypes.TEMPERATURE,
        nonAdditive: true,
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        label: 'Temperature',
        factor: 0.01,
        unit: Units.find(u => u.id === 'TEMPERATURE').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TEMPERATURE'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.TEMPERATURE),
        summary: true,
        allowNegative: true
    },
    {
        type: DataTypeTypes.EXTERNAL_TEMPERATURE,
        label: 'External Temperature',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'TEMPERATURE').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TEMPERATURE'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL),
        summary: false,
        isFromLocation: true,
        allowNegative: true
    },
    {
        type: DataTypeTypes.VOC,
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        label: 'Air Quality',
        factor: 0.01,
        unit: Units.find(u => u.id === 'INDOOR_AIR_QUALITY').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'INDOOR_AIR_QUALITY'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.INDOOR_AIR_QUALITY),
        summary: true
    },
    {
        type: DataTypeTypes.PRESSURE,
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        label: 'Pressure',
        factor: 0.1,
        unit: Units.find(u => u.id === 'PRESSURE').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'PRESSURE'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.PRESSURE),
        summary: true
    },
    {
        type: DataTypeTypes.CO2,
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        label: 'Carbon Dioxide',
        factor: 1,
        unit: Units.find(u => u.id === 'CO2').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CO2'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.CO2),
        summary: true
    },
    {
        type: DataTypeTypes.HUMIDITY,
        nonAdditive: true,
        label: 'Humidity',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'PERCENTAGE').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'PERCENTAGE'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.HUMIDITY),
        summary: true
    },
    {
        type: DataTypeTypes.EXTERNAL_HUMIDITY,
        label: 'External Humidity',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'PERCENTAGE').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'PERCENTAGE'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.HUMIDITY),
        summary: false,
        isFromLocation: true,
        allowNegative: false,
    },
    {
        type: DataTypeTypes.OCCUPANCY,
        label: 'Occupancy',
        graphType: 'bar',
        abstractType: AbstractDataType.CATEGORICAL,
        unit: Units.find(u => u.id === 'OCCUPANCY').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'OCCUPANCY'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.OCCUPANCY),
        summary: true
    },
    {
        type: DataTypeTypes.OPEN,
        label: 'Open/Close',
        abstractType: AbstractDataType.CATEGORICAL,
        unit: Units.find(u => u.id === 'OPEN_CLOSED').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'OPEN_CLOSED'),
        summary: true,
        graphType: 'line',
        category: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.OPEN_CLOSED)
    },
    {
        type: DataTypeTypes.LIGHT,
        label: 'Light',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'LUMINANCE').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'LUMINANCE'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ENVIRONMENTAL),
        modifier: ((v) => v !== null ? Math.round(Math.pow(10, ((v - 1) / 10000)) * 10) / 10 : null),
        summary: true
    },
    {
        type: DataTypeTypes.ASSET_BATTERY_PERCENT,
        label: 'Storage Percent',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'PERCENTAGE').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'PERCENTAGE'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM),
        summary: true
    },
    {
        type: DataTypeTypes.DELIVERED_WATER,
        dataTypeSibling: DataTypeTypes.WATER_PULSE,
        label: 'Usage',
        graphType: 'bar',
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find(u => u.id === 'CUBIC_METER').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CUBIC_METER'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.WATER).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.WATER)
    },
    {
        type: DataTypeTypes.WATER_PULSE,
        dataTypeSibling: DataTypeTypes.DELIVERED_WATER,
        label: 'Rate',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'CUBIC_METER').metaData.symbol + '/' + Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CUBIC_METER'),
        applyRate: true,
        rateUnitDetails: Units.find(u => u.id === 'TIME'),
        defaultRateMultiple: 3600,
        category: DataCategories.find(u => u.id === DataCategoryTypes.WATER).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.WATER),
        summary: true
    },
    {
        type: DataTypeTypes.WATER_PULSE_HOT,
        dataTypeSibling: DataTypeTypes.DELIVERED_WATER_HOT,
        label: 'Rate',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'CUBIC_METER').metaData.symbol + '/' + Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CUBIC_METER'),
        applyRate: true,
        rateUnitDetails: Units.find(u => u.id === 'TIME'),
        defaultRateMultiple: 3600,
        category: DataCategories.find(u => u.id === DataCategoryTypes.HOT_WATER).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.HOT_WATER),
        summary: true
    },
    {
        type: DataTypeTypes.CURRENT,
        label: 'Current',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        factor: 0.001,
        unit: Units.find(u => u.id === 'AMPERE').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'AMPERE'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.CURRENT),
    },
    {
        type: DataTypeTypes.EXPORTED_DELIVERED,
        dataTypeSibling: DataTypeTypes.EXPORTED_CONSUMPTION,
        label: 'Export',
        graphType: 'bar',
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find(u => u.id === 'WATT_HOUR').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'WATT_HOUR'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.EXPORTED),
        influxLoadTypes: {
            [LoadTypes.CONSUMPTION_ONLY]: null,
            [LoadTypes.GENERATION_ONLY]: null,
            [LoadTypes.CONSUMPTION_EXPORT]: influxLoadTypes.GENERATED
        },
        unsafeToRetrieveWithoutLoadType: true
    },
    {
        type: DataTypeTypes.EXPORTED_CONSUMPTION,
        dataTypeSibling: DataTypeTypes.EXPORTED_DELIVERED,
        desiredDirection: 'up',
        label: 'Export Rate',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'WATT').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'WATT'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.EXPORTED),
        flipNegative: true,
        removeNegative: true,
        summary: true,
        influxLoadTypes: {
            [LoadTypes.CONSUMPTION_ONLY]: null,
            [LoadTypes.GENERATION_ONLY]: null,
            [LoadTypes.CONSUMPTION_EXPORT]: influxLoadTypes.CONSUMPTION
        },
        unsafeToRetrieveWithoutLoadType: true
    },
    {
        type: DataTypeTypes.EXPORTED_DELIVERED_SPEND,
        label: 'Export Spend',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'CURRENCY').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CURRENCY'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.EXPORTED),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.EXPORTED_DELIVERED,
        tariffType: 'spend',
        tariffable: true
    },
    {
        type: DataTypeTypes.EXPORTED_DELIVERED_CARBON,
        label: 'Export Carbon',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'GRAM').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'GRAM'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.EXPORTED),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.EXPORTED_DELIVERED,
        tariffType: 'carbon',
        tariffable: true
    },
    {
        type: DataTypeTypes.IMPORTED_DELIVERED_SPEND,
        label: 'Import Spend',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'CURRENCY').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CURRENCY'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.IMPORTED),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.IMPORTED_DELIVERED,
        tariffType: 'spend',
        tariffable: true
    },
    {
        type: DataTypeTypes.IMPORTED_DELIVERED_CARBON,
        label: 'Import Carbon',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'GRAM').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'GRAM'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.IMPORTED),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.IMPORTED_DELIVERED,
        tariffType: 'carbon',
        tariffable: true
    },
    {
        type: DataTypeTypes.GENERATED_DELIVERED,
        dataTypeSibling: DataTypeTypes.GENERATED_CONSUMPTION,
        desiredDirection: 'up',
        label: 'Generation',
        graphType: 'bar',
        abstractType: AbstractDataType.AGGREGATE,
        unit: Units.find(u => u.id === 'WATT_HOUR').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'WATT_HOUR'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.GENERATION),
        summary: true,
        influxLoadTypes: {
            [LoadTypes.CONSUMPTION_ONLY]: null,
            [LoadTypes.GENERATION_ONLY]: influxLoadTypes.GENERATED,
            [LoadTypes.CONSUMPTION_EXPORT]: null
        },
        influxReverseLoadTypes: {
            [LoadTypes.CONSUMPTION_ONLY]: null,
            [LoadTypes.GENERATION_ONLY]: influxLoadTypes.GENERATED,
            [LoadTypes.CONSUMPTION_EXPORT]: null
        },
        unsafeToRetrieveWithoutLoadType: true
    },
    {
        type: DataTypeTypes.GENERATED_CONSUMPTION,
        dataTypeSibling: DataTypeTypes.GENERATED_DELIVERED,
        desiredDirection: 'up',
        label: 'Generation Rate',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'WATT').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'WATT'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.GENERATION),
        summary: true,
        influxLoadTypes: {
            [LoadTypes.CONSUMPTION_ONLY]: null,
            [LoadTypes.GENERATION_ONLY]: influxLoadTypes.CONSUMPTION,
            [LoadTypes.CONSUMPTION_EXPORT]: null
        },
        influxLegacyLoadTypes: {
            [LoadTypes.GENERATION_ONLY]: influxLoadTypes.DELIVERED
        },
        unsafeToRetrieveWithoutLoadType: true
    },
    {
        type: DataTypeTypes.GATEWAY_MOBILE_STRENGTH,
        desiredDirection: 'up',
        label: 'Mobile Signal Strength',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'DECIBEL').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'DECIBEL'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.SIGNAL),
        pythiaConfig: {
            translatedName: 'mobile_strength'
        }
    },
    {
        type: DataTypeTypes.GATEWAY_WIFI_STRENGTH,
        desiredDirection: 'up',
        label: 'WiFi Signal Strength',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        unit: Units.find(u => u.id === 'DECIBEL').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'DECIBEL'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.SYSTEM),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.SIGNAL),
        pythiaConfig: {
            resolution: 3600000,
            translatedName: 'wifi_strength',
            object: PythiaObjectType.GATEWAY
        }
    },
    {
        type: DataTypeTypes.DELIVERED_SPEND,
        label: 'Spend',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'CURRENCY').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CURRENCY'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED,
        tariffType: 'spend',
        tariffable: true
    },
    {
        type: DataTypeTypes.GENERATED_DELIVERED_SPEND,
        label: 'Generation Spend',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'CURRENCY').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CURRENCY'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        subCategory: DataCategories.find(u => u.id === DataCategoryTypes.GENERATION),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.GENERATED_DELIVERED,
        tariffType: 'spend',
        tariffable: true
    },
    {
        type: DataTypeTypes.DELIVERED_WATER_SPEND,
        label: 'Spend',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'CURRENCY').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CURRENCY'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.WATER).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.WATER),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED_WATER,
        tariffType: 'spend',
        tariffable: true
    },
    {
        type: DataTypeTypes.DELIVERED_WATER_HOT_SPEND,
        label: 'Spend',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'CURRENCY').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CURRENCY'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.HOT_WATER).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.HOT_WATER),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED_WATER_HOT,
        tariffType: 'spend',
        tariffable: true
    },
    {
        type: DataTypeTypes.DELIVERED_GAS_SPEND,
        label: 'Spend',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'CURRENCY').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CURRENCY'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.GAS),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED_GAS,
        tariffType: 'spend',
        tariffable: true
    },
    {
        type: DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND,
        label: 'Spend',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'CURRENCY').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'CURRENCY'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.GAS),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.GAS_ENERGY_DELIVERED,
        tariffType: 'spend',
        tariffable: true
    },
    {
        type: DataTypeTypes.DELIVERED_CARBON,
        label: 'Carbon',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'GRAM').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'GRAM'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED,
        tariffType: 'carbon',
        tariffable: true
    },
    {
        type: DataTypeTypes.GENERATED_DELIVERED_CARBON,
        label: 'Carbon',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'GRAM').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'GRAM'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.ELECTRICITY),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.GENERATED_DELIVERED,
        tariffType: 'carbon',
        tariffable: true
    },
    {
        type: DataTypeTypes.DELIVERED_WATER_CARBON,
        label: 'Carbon',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'GRAM').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'GRAM'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.WATER).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.WATER),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED_WATER,
        tariffType: 'carbon',
        tariffable: true
    },
    {
        type: DataTypeTypes.DELIVERED_WATER_HOT_CARBON,
        label: 'Carbon',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'GRAM').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'GRAM'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.HOT_WATER).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.HOT_WATER),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED_WATER_HOT,
        tariffType: 'carbon',
        tariffable: true
    },
    {
        type: DataTypeTypes.DELIVERED_GAS_CARBON,
        label: 'Carbon',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'GRAM').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'GRAM'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.GAS),
        downloadOnly: true,
        tariffComparatorDataType: DataTypeTypes.DELIVERED_GAS,
        tariffType: 'carbon',
        tariffable: true
    },
    {
        type: DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON,
        label: 'Carbon',
        graphType: 'bar',
        abstractType: AbstractDataType.TARIFF,
        factor: 1,
        unit: Units.find(u => u.id === 'GRAM').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'GRAM'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.GAS).name,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.GAS),
        downloadOnly: true,
        tariffable: true,
        tariffType: 'carbon',
        tariffComparatorDataType: DataTypeTypes.GAS_ENERGY_DELIVERED
    },
    {
        type: DataTypeTypes.ASSET_LAST_CONTACTED,
        label: 'Last contacted',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find(u => u.id === 'INTERNAL').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'INTERNAL'),
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'last_contacted',
            object: PythiaObjectType.ASSET
        }
    },
    {
        type: DataTypeTypes.GATEWAY_LAST_CONTACTED,
        label: 'Last contacted',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'last_contacted',
            object: PythiaObjectType.GATEWAY
        }
    },
    {
        type: DataTypeTypes.EVENT,
        label: 'Event',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
    },
    {
        type: DataTypeTypes.ERROR,
        label: 'Error',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
    },
    {
        type: DataTypeTypes.ASSET_FIRMWARE_VERSION,
        label: 'Firmware version',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.ASSET
        }
    },
    {
        type: DataTypeTypes.ASSET_FIRMWARE_PROGRESS,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.ASSET
        }
    },
    {
        type: DataTypeTypes.ASSET_USER_STATE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'user_state',
            object: PythiaObjectType.ASSET
        }
    },
    {
        type: DataTypeTypes.ASSET_CURRENT_STATE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'current_state',
            object: PythiaObjectType.ASSET
        }
    },
    {
        type: DataTypeTypes.ASSET_AUTOMATED_STATE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'automated_state',
            object: PythiaObjectType.ASSET
        }
    },
    {
        type: DataTypeTypes.ASSET_BOOST_FINISH,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'boost_finish',
            object: PythiaObjectType.ASSET
        }
    },
    {
        type: DataTypeTypes.ASSET_SNOOZE_FINISH,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'snooze_finish',
            object: PythiaObjectType.ASSET
        }
    },
    {
        type: DataTypeTypes.ASSET_SKU,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'sku',
            object: PythiaObjectType.ASSET
        }
    },
    {
        type: DataTypeTypes.MODBUS_MESSAGE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'modbus_message_rec',
            object: PythiaObjectType.GATEWAY
        }
    },
    {
        type: DataTypeTypes.ASSET_DISCONNECTED,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'disconnected',
            object: PythiaObjectType.ASSET
        }
    },
    {
        type: DataTypeTypes.ASSET_INTERMITTENT,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'intermittent',
            object: PythiaObjectType.ASSET
        }
    },
    {
        type: DataTypeTypes.ASSET_INTERMITTENT,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'intermittent',
            object: PythiaObjectType.ASSET
        }
    },
    {
        type: DataTypeTypes.GATEWAY_UPDATE_STATE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'update_state',
            object: PythiaObjectType.GATEWAY
        }
    },
    {
        type: DataTypeTypes.GATEWAY_ACTIVE_CONNECTION,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.CATEGORICAL,
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'active_connection',
            object: PythiaObjectType.GATEWAY
        }
    },
    {
        type: DataTypeTypes.GATEWAY_CHARGE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.INSTANTANEOUS,
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'charge',
            object: PythiaObjectType.GATEWAY
        }
    },
    {
        type: DataTypeTypes.GATEWAY_POWER_SOURCE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'power_source',
            object: PythiaObjectType.GATEWAY
        }
    },
    {
        type: DataTypeTypes.GATEWAY_IMSI,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'imsi',
            object: PythiaObjectType.GATEWAY
        }
    },
    {
        type: DataTypeTypes.GATEWAY_TRUST_LIST,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'trusted_list',
            object: PythiaObjectType.GATEWAY
        }
    },
    {
        type: DataTypeTypes.GATEWAY_DEVICE_ANALYSIS,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            translatedName: 'analysed_device',
            object: PythiaObjectType.GATEWAY
        }
    },
    {
        type: DataTypeTypes.GATEWAY_UPDATED,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.GATEWAY
        }
    },
    {
        type: DataTypeTypes.DEVICE_UPDATED,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.ASSET
        }
    },
    {
        type: DataTypeTypes.USER_RESYNC,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.GATEWAY
        }
    },
    {
        type: DataTypeTypes.GATEWAY_REPORTED_VERSION_ID,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.GATEWAY,
            translatedName: 'reported_version_id'
        }
    },
    {
        type: DataTypeTypes.RULES_UPDATED,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.MESSAGE,
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.RULE,
            translatedName: 'reported_version_id',
            channel: 'RULES_UPDATED'
        }
    },
    {
        type: DataTypeTypes.ANOMALIES_UPDATED,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.MESSAGE,
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.RULE,
            channel: 'ANOMALIES_UPDATED'
        }
    },
    {
        type: DataTypeTypes.GATEWAY_IP_ADDRESS,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.GATEWAY,
            translatedName: 'ip_address'
        }
    },
    {
        type: DataTypeTypes.CLIENT_UPDATE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
    },
    {
        type: DataTypeTypes.RULE_CLIENT_UPDATE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
    },
    {
        type: DataTypeTypes.ONLINE_STATE_UPDATE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.MESSAGE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
    },
    {
        type: DataTypeTypes.RULE_EVENT,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.EVENT,
        factor: 1,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.RULE
        }
    },
    {
        type: DataTypeTypes.DEMAND_PHASE_ONE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.ASSET,
            translatedName: 'demandPhaseOne'
        }
    },
    {
        type: DataTypeTypes.DEMAND_PHASE_TWO,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.ASSET,
            translatedName: 'demandPhaseTwo'
        }
    },
    {
        type: DataTypeTypes.DEMAND_PHASE_THREE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.ASSET,
            translatedName: 'demandPhaseThree'
        }
    },
    {
        type: DataTypeTypes.PF_PHASE_ONE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.ASSET,
            translatedName: 'pfPhaseOne'
        }
    },
    {
        type: DataTypeTypes.PF_PHASE_TWO,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.ASSET,
            translatedName: 'pfPhaseTwo'
        }
    },
    {
        type: DataTypeTypes.PF_PHASE_THREE,
        label: 'Firmware progress',
        graphType: 'line',
        abstractType: AbstractDataType.ONCE,
        categoryDetails: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL),
        factor: 1,
        unit: Units.find(u => u.id === 'TIME').metaData.symbol,
        unitDetails: Units.find(u => u.id === 'TIME'),
        category: DataCategories.find(u => u.id === DataCategoryTypes.INTERNAL).name,
        downloadOnly: true,
        pythiaConfig: {
            object: PythiaObjectType.ASSET,
            translatedName: 'pfPhaseThree'
        }
    },
];
// Changes to make custom data types work
DataTypesArray = DataTypesArray.map((dt) => {
    dt.id = dt.type;
    dt.name = dt.label;
    dt.dataType = dt.applyRate ? AbstractDataType.INSTANTANEOUS : dt.unitDetails && dt.unitDetails.dataType ? dt.unitDetails.dataType : dt.graphType === 'line' ? AbstractDataType.INSTANTANEOUS : AbstractDataType.AGGREGATE;
    if (dt.unitDetails) {
        dt.unitId = dt.unitDetails.id;
    }
    if (dt.subCategory && dt.categoryDetails) {
        dt.categoryDetails = Object.assign(Object.assign({}, dt.categoryDetails), { position: dt.subCategory.position, color: dt.subCategory.color, icon: dt.subCategory.icon });
    }
    if (dt.categoryDetails) {
        dt.categoryId = dt.categoryDetails.id;
    }
    if (dt.applyRate && dt.rateUnitDetails) {
        dt.rateUnitId = dt.rateUnitDetails.id;
    }
    if (!dt.label) {
        dt.label = '';
    }
    return dt;
}).sort((a, b) => { var _a, _b; return ((_a = a.categoryDetails) === null || _a === void 0 ? void 0 : _a.position) - ((_b = b.categoryDetails) === null || _b === void 0 ? void 0 : _b.position); });
const DataTypes = createMappingArray(DataTypesArray, 'type');
exports.DataTypes = DataTypes;
const Options = [
    {
        label: 'On',
        state: 'ON',
        default: true,
        color: '#49c570'
    },
    {
        label: 'Off',
        state: 'OFF',
        color: '#ff5c5c'
    },
    {
        label: 'Following Rule',
        state: 'AUTOMATED',
        icon: 'FaCalculator',
        nonSelectable: true
    },
    {
        state: 'BOOST',
        nonSelectable: true
    },
    {
        state: 'SNOOZE',
        nonSelectable: true
    },
    {
        label: 'None',
        state: 'NONE',
        color: '#cccccc'
    },
    {
        label: 'Monitoring',
        state: 'MONITORING',
        color: '#03a9f4',
        nonSelectable: true
    }
];
let StateOptions = [
    {
        type: 'default',
        label: 'Default GridDuck Asset',
        hiddenFromDashAddDevice: true,
        resolution: 5 * 60 * 1000,
        connection: Connections.ZIGBEE,
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
            Options.find(o => o.state === 'ON'),
            Options.find(o => o.state === 'OFF'),
            Options.find(o => o.state === 'AUTOMATED'),
            Options.find(o => o.state === 'BOOST'),
            Options.find(o => o.state === 'SNOOZE'),
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'INITIALISING_SKU',
        label: 'Device Initialising...',
        hiddenFromDashAddDevice: true,
        resolution: 5 * 60 * 1000,
        connection: Connections.ZIGBEE,
        dataTypes: [],
        options: []
    },
    {
        type: 'PLU-UK',
        connection: Connections.ZIGBEE,
        label: 'UK Plug',
        resolution: 5 * 60 * 1000,
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
            Options.find(o => o.state === 'ON'),
            Options.find(o => o.state === 'OFF'),
            Options.find(o => o.state === 'AUTOMATED'),
            Options.find(o => o.state === 'BOOST'),
            Options.find(o => o.state === 'SNOOZE'),
            Options.find(o => o.state === 'MONITORING')
        ]
    },
    {
        type: 'SOCKET-DOUBLE-OWON',
        connection: Connections.ZIGBEE,
        label: 'UK Double Socket',
        resolution: 5 * 60 * 1000,
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
            Options.find(o => o.state === 'ON'),
            Options.find(o => o.state === 'OFF'),
            Options.find(o => o.state === 'AUTOMATED'),
            Options.find(o => o.state === 'BOOST'),
            Options.find(o => o.state === 'SNOOZE'),
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'INL-SWI',
        connection: Connections.ZIGBEE,
        label: 'Inline Switch',
        resolution: 5 * 60 * 1000,
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
            Options.find(o => o.state === 'ON'),
            Options.find(o => o.state === 'OFF'),
            Options.find(o => o.state === 'AUTOMATED'),
            Options.find(o => o.state === 'BOOST'),
            Options.find(o => o.state === 'SNOOZE'),
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'POWERVAULT',
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.API,
        resolution: 5 * 60 * 1000,
        label: 'Powervault Secondary Asset',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ],
        allowNegative: true
    },
    {
        type: 'CLI-SEN-POW',
        resolution: 5 * 60 * 1000,
        connection: Connections.ZIGBEE,
        label: 'Powered Clamp Meter',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'SEN-POW-OWON',
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1000,
        label: 'Powered Clamp Meter',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.CURRENT),
            DataTypes.find(t => t.type === DataTypeTypes.GENERATED_DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.GENERATED_CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.EXPORTED_CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.EXPORTED_DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.EXPORTED_DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.EXPORTED_DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.IMPORTED_CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.IMPORTED_DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.IMPORTED_DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.IMPORTED_DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.GENERATED_DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.GENERATED_DELIVERED_SPEND)
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ],
        allowNegative: true
    },
    {
        type: 'SEN-POW-PRE',
        connection: Connections.PRESSAC,
        resolution: 5 * 60 * 1000,
        label: 'Self Powered CT',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.CURRENT),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'POWER_RADAR',
        hiddenFromDashAddDevice: true,
        noHub: true,
        connection: Connections.POWER_RADAR,
        resolution: 60 * 60 * 1000,
        noDisconnection: true,
        label: 'Power Radar',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.CURRENT)
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'LOG_STASH',
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.API,
        resolution: 60 * 60 * 1000,
        noDisconnection: true,
        label: 'Log Stash',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'FUDURA',
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.API,
        resolution: 60 * 60 * 1000,
        noDisconnection: true,
        label: 'Fudura',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'SOLAR_EDGE',
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.SOLAR_EDGE,
        resolution: 15 * 60 * 1000,
        noDisconnection: true,
        label: 'Solar Edge',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.GENERATED_CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.GENERATED_DELIVERED),
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ],
    },
    {
        type: 'POWER_RADAR_METER_GAS',
        hiddenFromDashAddDevice: true,
        noHub: true,
        connection: Connections.POWER_RADAR,
        resolution: 60 * 60 * 1000,
        noDisconnection: true,
        label: 'Power Radar Gas Meter',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_CARBON)
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'POWER_RADAR_METER_WATER',
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.POWER_RADAR,
        resolution: 60 * 60 * 1000,
        noDisconnection: true,
        label: 'Power Radar Water Meter',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.WATER_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'SEN-POW-OWON-OLD',
        hiddenFromDashAddDevice: true,
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1000,
        label: 'Powered Clamp Meter',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.CURRENT),
            DataTypes.find(t => t.type === DataTypeTypes.EXPORTED_CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.EXPORTED_DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.GENERATED_DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.GENERATED_CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.EXPORTED_DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.EXPORTED_DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.IMPORTED_CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.IMPORTED_DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.IMPORTED_DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.IMPORTED_DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.GENERATED_DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.GENERATED_DELIVERED_SPEND)
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ],
        allowNegative: true
    },
    {
        type: 'SEN-POW',
        hiddenFromDashAddDevice: true,
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1000,
        label: 'Battery Clamp Meter',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_VOLTAGE)
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'MET-REA',
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1000,
        label: 'Meter Reader',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'MET-REA_FRIENT',
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1000,
        label: 'Meter Reader',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'SEN-TEM-PROBE',
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1000,
        label: 'Temperature Probe',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.TEMPERATURE),
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'SEN-TEM-HUM',
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1000,
        label: 'Temperature/Humidity Sensor',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.TEMPERATURE),
            DataTypes.find(t => t.type === DataTypeTypes.HUMIDITY),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: "SEN-LIGHT-MOTION",
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1000,
        label: 'Light/Occupancy Sensor',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.LIGHT),
            DataTypes.find(t => t.type === DataTypeTypes.OCCUPANCY),
            DataTypes.find(t => t.type === DataTypeTypes.TEMPERATURE),
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: "VIRTUAL-PARENT",
        icon: 'AiOutlineSisternode',
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.VIRTUAL,
        virtual: true,
        noDisconnection: true,
        label: 'Virtual Parent',
        dataTypes: DataTypes.filter(t => t.categoryDetails),
        // dataTypes: [],
        options: [
            Options.find(o => o.state === 'NONE')
        ]
    },
    {
        type: "VIRTUAL-PARENT-MERGED",
        icon: 'IoMdGitMerge',
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.VIRTUAL,
        virtual: true,
        noDisconnection: true,
        label: 'Merged Virtual Parent',
        dataTypes: DataTypes.filter(t => t.categoryDetails),
        // dataTypes: [],
        options: [
            Options.find(o => o.state === 'NONE')
        ]
    },
    {
        type: 'POWERVAULT_BATTERY',
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.API,
        resolution: 5 * 60 * 1000,
        label: 'Powervault Battery',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_PERCENT)
        ],
        options: [
            Options.find(o => o.state === 'MONITORING'),
            {
                label: 'Only Charge',
                state: 'ONLY_CHARGE',
                color: '#4dc7d2'
            },
            {
                label: 'Force Charge',
                state: 'FORCE_CHARGE',
                color: '#4d5fd2'
            },
            {
                label: 'Only Discharge',
                state: 'ONLY_DISCHARGE',
                color: '#ff87a7'
            },
            {
                label: 'Force Discharge',
                state: 'FORCE_DISCHARGE',
                color: '#fa2488'
            },
            {
                label: 'Normal',
                default: true,
                state: 'NORMAL',
                color: '#49c570'
            },
            {
                label: 'Disable',
                state: 'DISABLE',
                color: '#ff5c5c'
            }
        ],
        allowNegative: true
    },
    {
        type: 'REL-DIN',
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1000,
        label: '16A DIN Relay',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
            {
                label: 'On',
                state: 'ON',
                default: true,
                color: '#49c570'
            },
            {
                label: 'Off',
                state: 'OFF',
                color: '#ff5c5c'
            },
            {
                label: 'Following Rule',
                state: 'AUTOMATED',
                icon: 'FaCalculator',
                nonSelectable: true
            },
            {
                state: 'BOOST',
                nonSelectable: true
            },
            {
                state: 'SNOOZE',
                nonSelectable: true
            },
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'REL-DIN-30A',
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1000,
        label: '30A DIN Relay',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
            {
                label: 'On',
                state: 'ON',
                default: true,
                color: '#49c570'
            },
            {
                label: 'Off',
                state: 'OFF',
                color: '#ff5c5c'
            },
            {
                label: 'Following Rule',
                state: 'AUTOMATED',
                icon: 'FaCalculator',
                nonSelectable: true
            },
            {
                state: 'BOOST',
                nonSelectable: true
            },
            {
                state: 'SNOOZE',
                nonSelectable: true
            },
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'REL-DIN-32A-OWON',
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1000,
        label: '32A DIN Relay',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH)
        ],
        options: [
            {
                label: 'On',
                state: 'ON',
                default: true,
                color: '#49c570'
            },
            {
                label: 'Off',
                state: 'OFF',
                color: '#ff5c5c'
            },
            {
                label: 'Following Rule',
                state: 'AUTOMATED',
                icon: 'FaCalculator',
                nonSelectable: true
            },
            {
                state: 'BOOST',
                nonSelectable: true
            },
            {
                state: 'SNOOZE',
                nonSelectable: true
            },
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'MODBUS',
        hiddenFromDashAddDevice: true,
        connection: Connections.MODBUS_RTU,
        label: 'Modbus Device',
        resolution: 5 * 60 * 1000,
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'BACNET_IP_ELECTRICITY',
        hiddenFromDashAddDevice: false,
        connection: Connections.BACNET_TCP_IP,
        label: 'BACnet IP Electricity Meter',
        resolution: 5 * 60 * 1000,
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'BACNET_IP_TEMPERATURE',
        hiddenFromDashAddDevice: false,
        connection: Connections.BACNET_TCP_IP,
        label: 'BACnet IP Temperature Sensor',
        resolution: 5 * 60 * 1000,
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.TEMPERATURE),
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'BACNET_IP_WATER',
        hiddenFromDashAddDevice: false,
        connection: Connections.BACNET_TCP_IP,
        label: 'BACnet IP Water Meter',
        resolution: 5 * 60 * 1000,
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER),
            DataTypes.find(t => t.type === DataTypeTypes.WATER_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_SPEND),
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'BACNET_IP_GAS',
        hiddenFromDashAddDevice: false,
        connection: Connections.BACNET_TCP_IP,
        label: 'BACnet IP Gas Meter',
        resolution: 5 * 60 * 1000,
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON),
        ],
        forwardDataTypes: {
            [DataTypeTypes.GAS_ENERGY_DELIVERED]: {
                dataType: DataTypeTypes.DELIVERED_GAS,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND]: {
                dataType: DataTypeTypes.DELIVERED_GAS_SPEND,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON]: {
                dataType: DataTypeTypes.DELIVERED_GAS_CARBON,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_CONSUMPTION]: {
                dataType: DataTypeTypes.GAS_PULSE,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            }
        },
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'EMLITE',
        noHub: true,
        hiddenFromDashAddDevice: true,
        connection: Connections.EMLITE,
        label: 'Emlite Meter',
        resolution: 60 * 60 * 1000,
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON)
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'EA_GAS',
        hiddenFromDashAddDevice: true,
        connection: Connections.API,
        resolution: 5 * 60 * 1000,
        label: 'EnergyAsset Gas Data',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_CARBON)
        ],
        forwardDataTypes: {
            [DataTypeTypes.GAS_ENERGY_DELIVERED]: {
                dataType: DataTypeTypes.DELIVERED_GAS,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND]: {
                dataType: DataTypeTypes.DELIVERED_GAS_SPEND,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON]: {
                dataType: DataTypeTypes.DELIVERED_GAS_CARBON,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_CONSUMPTION]: {
                dataType: DataTypeTypes.GAS_PULSE,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            }
        },
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'BLE_PULSE',
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1000,
        label: 'BLE Pulse Counter',
        maxInstances: 3,
        macLength: 12,
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.WATER_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.WATER_PULSE_HOT),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_HOT),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_HOT_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_HOT_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON)
        ],
        forwardDataTypes: {
            [DataTypeTypes.GAS_ENERGY_DELIVERED]: {
                dataType: DataTypeTypes.DELIVERED_GAS,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND]: {
                dataType: DataTypeTypes.DELIVERED_GAS_SPEND,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON]: {
                dataType: DataTypeTypes.DELIVERED_GAS_CARBON,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_CONSUMPTION]: {
                dataType: DataTypeTypes.GAS_PULSE,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            }
        },
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'BLE_PULSE_DELIVERED',
        hiddenFromDashAddDevice: true,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1000,
        maxInstances: 3,
        macLength: 12,
        label: 'BLE Pulse Counter (Electricity)',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'BLE_PULSE_DELIVERED_WATER',
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1000,
        label: 'BLE Pulse Counter (Water)',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.WATER_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_CARBON)
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'BLE_PULSE_DELIVERED_WATER_HOT',
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1000,
        label: 'BLE Pulse Counter (Hot Water)',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.WATER_PULSE_HOT),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_HOT),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_HOT_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_HOT_CARBON)
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'BLE_PULSE_DELIVERED_GAS',
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1000,
        label: 'BLE Pulse Counter (Gas)',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.GAS_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_CARBON)
        ],
        forwardDataTypes: {
            [DataTypeTypes.GAS_ENERGY_DELIVERED]: {
                dataType: DataTypeTypes.DELIVERED_GAS,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND]: {
                dataType: DataTypeTypes.DELIVERED_GAS_SPEND,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON]: {
                dataType: DataTypeTypes.DELIVERED_GAS_CARBON,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_CONSUMPTION]: {
                dataType: DataTypeTypes.GAS_PULSE,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            }
        },
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'TRV-DANFOSS',
        hiddenFromDashAddDevice: true,
        connection: Connections.ZIGBEE,
        resolution: 5 * 60 * 1000,
        label: 'Radiator TRV',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.TEMPERATURE),
        ],
        options: [
            Options.find(o => o.state === 'ON'),
            Options.find(o => o.state === 'OFF'),
            Options.find(o => o.state === 'AUTOMATED'),
            Options.find(o => o.state === 'BOOST'),
            Options.find(o => o.state === 'SNOOZE'),
            Options.find(o => o.state === 'MONITORING'),
        ]
    },
    {
        type: 'NB-IOT-PULSE',
        noHub: true,
        connection: Connections.NB_IOT,
        macLength: 12,
        maxInstances: 3,
        resolution: 3 * 60 * 60 * 1000,
        label: 'NB-IoT Pulse Counter',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.NB_IOT_ECL),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS),
            DataTypes.find(t => t.type === DataTypeTypes.NB_IOT_ECL),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.WATER_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.NB_IOT_ECL),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.WATER_PULSE_HOT),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_HOT),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_HOT_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.NB_IOT_ECL),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_HOT_CARBON)
        ],
        forwardDataTypes: {
            [DataTypeTypes.GAS_ENERGY_DELIVERED]: {
                dataType: DataTypeTypes.DELIVERED_GAS,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND]: {
                dataType: DataTypeTypes.DELIVERED_GAS_SPEND,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON]: {
                dataType: DataTypeTypes.DELIVERED_GAS_CARBON,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_CONSUMPTION]: {
                dataType: DataTypeTypes.GAS_PULSE,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            }
        },
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'NB-IOT-PULSE_DELIVERED',
        connection: Connections.NB_IOT,
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        resolution: 3 * 60 * 60 * 1000,
        label: 'NB-IoT Pulse Counter (Electricity)',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.NB_IOT_ECL),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'NB-IOT-PULSE_DELIVERED_WATER',
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1000,
        label: 'NB-IoT Pulse Counter (Water)',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.WATER_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.NB_IOT_ECL),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_CARBON)
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'NB-IOT-PULSE_DELIVERED_WATER_HOT',
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1000,
        label: 'NB-IoT Pulse Counter (Hot Water)',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.WATER_PULSE_HOT),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_HOT),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_HOT_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.NB_IOT_ECL),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_WATER_HOT_CARBON)
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'NB-IOT-PULSE_DELIVERED_GAS',
        hiddenFromDashAddDevice: true,
        maxInstances: 3,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1000,
        label: 'NB-IoT Pulse Counter (Gas)',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.GAS_PULSE),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_CONSUMPTION),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON),
            DataTypes.find(t => t.type === DataTypeTypes.NB_IOT_ECL),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_SPEND),
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED_GAS_CARBON)
        ],
        forwardDataTypes: {
            [DataTypeTypes.GAS_ENERGY_DELIVERED]: {
                dataType: DataTypeTypes.DELIVERED_GAS,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_DELIVERED_SPEND]: {
                dataType: DataTypeTypes.DELIVERED_GAS_SPEND,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_DELIVERED_CARBON]: {
                dataType: DataTypeTypes.DELIVERED_GAS_CARBON,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            },
            [DataTypeTypes.GAS_ENERGY_CONSUMPTION]: {
                dataType: DataTypeTypes.GAS_PULSE,
                calculation: defaultModifiers[ModifierTypes.GAS_ENERGY_CONVERSION]
            }
        },
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'BLE_VOC',
        macLength: 12,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1000,
        label: 'BLE Air Quality Sensor',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.TEMPERATURE),
            DataTypes.find(t => t.type === DataTypeTypes.HUMIDITY),
            DataTypes.find(t => t.type === DataTypeTypes.VOC),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'BLE_TEMP',
        macLength: 12,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1000,
        label: 'BLE Temperature/Humidity Sensor',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.TEMPERATURE),
            DataTypes.find(t => t.type === DataTypeTypes.HUMIDITY),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'NB-IOT-TEMP',
        noHub: true,
        maxInstances: 1,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1000,
        label: 'NB-IoT Temperature Sensor',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.TEMPERATURE),
            DataTypes.find(t => t.type === DataTypeTypes.HUMIDITY),
            DataTypes.find(t => t.type === DataTypeTypes.NB_IOT_ECL),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'NB-IOT-VOC',
        noHub: true,
        maxInstances: 1,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1000,
        label: 'NB-IoT VOC Sensor',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.TEMPERATURE),
            DataTypes.find(t => t.type === DataTypeTypes.VOC),
            DataTypes.find(t => t.type === DataTypeTypes.HUMIDITY),
            DataTypes.find(t => t.type === DataTypeTypes.NB_IOT_ECL),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'NB-IOT-CO2',
        noHub: true,
        maxInstances: 1,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1000,
        label: 'NB-IoT CO2 Sensor',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.TEMPERATURE),
            DataTypes.find(t => t.type === DataTypeTypes.HUMIDITY),
            DataTypes.find(t => t.type === DataTypeTypes.CO2),
            DataTypes.find(t => t.type === DataTypeTypes.PRESSURE),
            DataTypes.find(t => t.type === DataTypeTypes.NB_IOT_ECL),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'NB-IOT-OPEN',
        noHub: true,
        maxInstances: 1,
        macLength: 12,
        connection: Connections.NB_IOT,
        resolution: 3 * 60 * 60 * 1000,
        label: 'NB-IoT Open/Close Sensor',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.OPEN),
            DataTypes.find(t => t.type === DataTypeTypes.NB_IOT_ECL),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'BLE_OPEN_CLOSE',
        maxInstances: 1,
        macLength: 12,
        connection: Connections.BLUETOOTH,
        resolution: 5 * 60 * 1000,
        label: 'BLE Open/Close Sensor',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.OPEN),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_SIGNAL_STRENGTH),
            DataTypes.find(t => t.type === DataTypeTypes.ASSET_BATTERY_ALARM),
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'SENSE-ANYWHERE',
        noHub: true,
        maxInstances: 1,
        macLength: 10,
        connection: Connections.SENSE_ANYWHERE,
        resolution: 3 * 60 * 60 * 1000,
        label: 'Sense Anywhere Sensor',
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.TEMPERATURE),
            DataTypes.find(t => t.type === DataTypeTypes.HUMIDITY),
            DataTypes.find(t => t.type === DataTypeTypes.CO2),
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'CONSULTUS',
        noHub: true,
        maxInstances: 1,
        macLength: 13,
        connection: Connections.CONSULTUS,
        resolution: 30 * 60 * 1000,
        label: 'Consultus Meter',
        hiddenFromDashAddDevice: true,
        dataTypes: [
            DataTypes.find(t => t.type === DataTypeTypes.DELIVERED),
            DataTypes.find(t => t.type === DataTypeTypes.CONSUMPTION),
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
    {
        type: 'MANUAL_IMPORT',
        noHub: true,
        maxInstances: 1,
        macLength: 13,
        connection: Connections.DATA_UPLOAD,
        resolution: 30 * 60 * 1000,
        label: 'Manual Import',
        dataTypes: [
            DataTypes.DELIVERED,
            DataTypes.CONSUMPTION,
            DataTypes.DELIVERED_GAS,
            DataTypes.GAS_PULSE,
            DataTypes.DELIVERED_WATER,
            DataTypes.WATER_PULSE,
            DataTypes.TEMPERATURE,
            DataTypes.HUMIDITY,
        ],
        options: [
            {
                label: 'Monitoring',
                state: 'MONITORING',
                color: '#03a9f4',
                nonSelectable: true
            }
        ]
    },
];
exports.StateOptions = StateOptions;
exports.StateOptions = StateOptions = StateOptions.map((so) => {
    // BACnet/IP devices are addressed by IP, not a MAC address, so they must
    // not receive the default macLength (which would force a MAC Address field).
    if (!so.macLength && so.connection !== Connections.BACNET_TCP_IP) {
        so.macLength = 16;
    }
    if (!so.maxInstances) {
        so.maxInstances = 1;
    }
    return so;
});
const GatewayOptions = [
    {
        type: 'DEVELCO-HUB',
        resolution: 10 * 60 * 1000 //10 mins
    },
    {
        type: 'ACRIOS-HUB',
        resolution: 60 * 60 * 1000 // 1 hour
    }
];
exports.GatewayOptions = GatewayOptions;
let DeviceOptions = StateOptions;
exports.DeviceOptions = DeviceOptions;
